/* eslint-disable object-shorthand */
/* eslint-disable no-param-reassign */
import {
  formatNumberWithCommaAndDollar,
  numberFormatter,
} from "@src/constants";
import Colors from "@src/constants/Colors";

export const foodBarChartOptions = {
  indexAxis: "y" as const,
  borderSkipped: true,
  scales: {
    x: {
      border: {
        color: Colors?.primarygray_300,
        width: 2,
      },
      stacked: true,
      ticks: {
        maxTicksLimit: 5,
        family: "'Ringside Regular-Book'",
        beginAtZero: true,
        precision: 0,
        callback: (value: string | number) => {
          return numberFormatter(Number(value));
        },
      },
      grid: {
        tickColor: Colors?.primarygray_400,
        lineWidth: 2,
        drawOnChartArea: false,
        drawTicks: true,
      },
    },
    y: {
      afterFit(scale: any) {
        scale.width = 85;
        scale.ticks = scale.ticks.map((tick: any, index: any) => {
          const tickvalue =
            tick.label.length > 11
              ? `${tick.label.slice(0, 8)}...`
              : tick.label;
          scale.ticks[index].label = tickvalue;
          return scale.ticks[index];
        });
      },
      border: {
        color: Colors?.primarygray_400,
        width: 2,
      },
      stacked: true,
      grid: {
        display: false,
      },
      ticks: {
        maxTicksLimit: 5,
        crossAlign: "far" as "center" | "far" | "near" | undefined,
        align: "center" as "start" | "center" | "end" | "inner",
        font: {
          family: "'Ringside Regular-Book'",
          size: 14,
        },
      },
    },
  },
  plugins: {
    tooltip: {
      callbacks: {
        label(context: any) {
          let label = context.dataset.label || "";

          if (label) {
            label += ": ";
          }
          if (context.parsed.x !== null) {
            label += formatNumberWithCommaAndDollar(context.parsed.x);
          }
          return label;
        },
      },
    },
    legend: {
      labels: {
        padding: 15,
        usePointStyle: true,
        pointStyle: "rectRounded",
        font: {
          family: "'Ringside Regular-Bold'",
        },
      },
      align: "start" as "start" | "center" | "end" | undefined,
      position: "right" as
        | "right"
        | "center"
        | "top"
        | "bottom"
        | "left"
        | "chartArea"
        | undefined,
    },
  },
};

export const alcoholBarchartOptions = {
  indexAxis: "y" as const,
  borderSkipped: true,
  scales: {
    x: {
      offset: false,
      border: {
        color: Colors?.primarygray_400,
        width: 2,
      },
      stacked: true,
      ticks: {
        maxTicksLimit: 5,
        family: "'Ringside Regular-Book'",
        beginAtZero: true,
        precision: 0,
        callback: (value: string | number) => {
          if (Number(value) > 1000) {
            return `${Number(value) / 1000}k`;
          }

          return `${value}`;
        },
      },
      grid: {
        tickColor: Colors?.primarygray_400,
        lineWidth: 2,
        drawOnChartArea: false,
        drawTicks: true,
      },
    },
    y: {
      afterFit(scale: any) {
        scale.width = 85;
        scale.ticks = scale.ticks.map((tick: any, index: any) => {
          const tickvalue =
            tick.label.length > 11
              ? `${tick.label.slice(0, 8)}...`
              : tick.label;
          scale.ticks[index].label = tickvalue;
          return scale.ticks[index];
        });
      },
      border: {
        color: Colors?.primarygray_400,
        width: 2,
      },
      stacked: true,
      grid: {
        display: false,
      },
      ticks: {
        maxTicksLimit: 5,
        crossAlign: "far" as "center" | "far" | "near" | undefined,
        align: "center" as "start" | "center" | "end" | "inner",
        font: {
          family: "'Ringside Regular-Book'",
          size: 14,
        },
      },
    },
  },
  plugins: {
    tooltip: {
      callbacks: {
        label(context: any) {
          let label = context.dataset.label || "";

          if (label) {
            label += ": ";
          }
          if (context.parsed.x !== null) {
            label += formatNumberWithCommaAndDollar(context.parsed.x);
          }
          return label;
        },
      },
    },
    legend: {
      labels: {
        padding: 15,
        usePointStyle: true,
        pointStyle: "rectRounded",
        font: {
          family: "'Ringside Regular-Bold'",
        },
      },
      align: "start" as "start" | "center" | "end" | undefined,
      position: "right" as
        | "right"
        | "center"
        | "top"
        | "bottom"
        | "left"
        | "chartArea"
        | undefined,
    },
  },
};

// Functions
export const getRefinedData = (data: any) => {
  return {
    netFoodSales: data.net_food_sales,
    netAlcoholSales: data.net_alc_sales,
    topFiveFoods: data.top_5_food,
    topFiveAlcohol: data.top_5_alc,
  };
};
